export default __webpack_public_path__ + "static/media/TheAmbush.61374cf9.mp4";